import { get, post } from '../../../../api/axios';
import { SetupEndpoints } from '../../../../api/endpoints/SetupEndpoints';
import { type CompanyDto } from '../../../models/CompanyDto';
import { type SetupRequestDto } from '../../../models/SetupRequestDto';
import { type AttachmentDto } from '../../../models/AttachmentDto';
import type { AxiosProgressEvent } from 'axios';

export const setupCompany = (setupData: SetupRequestDto) => {
  return post(SetupEndpoints.setup, setupData);
};

export const setupLogo = (image: File, onUploadProgress: (progressEvent: AxiosProgressEvent) => void) => {
  const fileName = image.name.length > 80 ? `${image.name.slice(0, 80)}.${image.name.split('.').pop()}` : image.name;
  const formData = new FormData();
  formData.append('file', new File([image], fileName, { type: image.type }));
  return post<AttachmentDto>(SetupEndpoints.setLogo, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

export const getSetupDetails = () => {
  return get<CompanyDto>(SetupEndpoints.setup);
};
